import { render } from "./VehicleReportCard.vue?vue&type=template&id=0f36dd5c&scoped=true"
import script from "./VehicleReportCard.vue?vue&type=script&lang=js"
export * from "./VehicleReportCard.vue?vue&type=script&lang=js"

import "./VehicleReportCard.vue?vue&type=style&index=0&id=0f36dd5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f36dd5c"]])

export default __exports__